import styled, { css } from "styled-components";
import { media } from "../../common/media";
import searchIcon from "../../../images/search-icon.svg";

const HeaderContainer = styled.div`
  height: 100%;
  height: 80px;
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  padding: 0 20px;

  #topSearchBox {
    border-radius: 0px !important;
  }

  ${media.tablet`
    padding: 0 10px;
  `};

  &#navigation {
    position: fixed;
    width: 100%;
    top: 0;
    background: #2f2f2f !important;
    z-index: 1031;

    .mini-nav-button {
      display: none;
      text-align: center;
      font-size: 25px;
      cursor: pointer;
      color: white;
      border-radius: 50% !important;
      ${media.desktop`
        display: block;
      `}

      &.clicked {
        color: ${(props) => props.theme.colorFlamingo};
      }
    }

    ${(props) =>
      props.scrolling === "true"
        ? css`
            background: #fff;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
            max-height: 80px;
            ${media.desktop`
              .lp-cart-account {
                .mobileMenu {
                  background: #fff;

                  .lp-nav-container {
                    background: transparent;
                  }
                }
              }
            `};
          `
        : css`
            background: transparent;
            box-shadow: none;
          `};

    ${media.desktop`
      display: flex;
      align-items: center;
      justify-content: space-between;
    `};

    .jukin-logo {
      z-index: 2001;
      position: relative;
      margin: 25px;
      ${media.phone`
        transform: initial;
        top: 0;
        margin: 0;
        left: 0;
      `};

      a.logo {
        display: block;
        svg.logo {
          width: 34px;
          height: 31px;
          ${media.tablet`
            padding-left: 10px;
          `};
        }
      }
    }
  }

  .st0 {
    fill: #1ebec8;
  }

  .st1 {
    fill: #fff;
  }

  .lp-cart-account {
    width: 100%;

    ${media.desktop`
      position: absolute;
      bottom: 0;
      left: 0;
      transform: translateY(100%);

      .mobileMenu {
        display: none;
        transition: all .6s ease 0s;

        &.is-show-mobile {
          display: block;
        }

        .lp-cart-dropdown {
          padding: 0;
        }
      }
    `};

    .lp-nav-container {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      @media screen and (min-width: 991px) and (max-width: 1440px) {
        flex-start;
      }
      align-content: flex-start;
      align-items: flex-start;

      ${media.desktop`
        background: rgba(0, 0, 0, 0.5);
      `};

      .lp-nav-item,
      .lp-nav-item .mega-dropdown {
        button {
          text-transform: none;
          transition: all 0.6s ease 0s;
        }
        a {
          transition: all 0.6s ease 0s;
          font-size: 14px;
          &.cart-clicker {
            font-size: 23px;
            color: transparent;
          }
          &.haveVid {
            color: transparent;
            font-size: 23px;
          }
        }
        margin-right: 5px;
        @media screen and (min-width: 992px) and (max-width: 1034px) {
          margin-right: 20px;
        }
        ${(props) =>
          props.scrolling === "true"
            ? css`
                color: #fff;
              `
            : css`
                color: #fff;
              `};

        > a,
        button {
          font-size: 14px;
          @media screen and (min-width: 991px) and (max-width: 1440px) {
            font-size: 13px;
          }
          ${(props) =>
            props.scrolling === "true"
              ? css`
                  color: #fff;
                `
              : css`
                  color: #fff;
                `};
          &:hover {
            color: #1ebec8;
            background: #transparent;
          }
          &.have-video {
            svg {
              margin-left: -25px;
            }
          }
        }

        button {
          &:hover {
            background: transparent;
          }
          &.top-nav-bt {
            width: 80px;
            font-size: 14px;
            @media screen and (min-width: 991px) and (max-width: 1440px) {
              font-size: 13px;
            }
            height: 36px;
            cursor: pointer;
            transition: all 0.6s ease 0s;
            text-transform: uppercase;
            ${media.phone`
              font-size: 12px;
            `}
            &.signup {
              background: #1ebec8;
              color: #fff;
              &:hover {
                background: #000;
                color: #fff;
              }
            }
            &.signin {
              ${(props) =>
                props.scrolling === "true"
                  ? css`
                      border: 1px solid #1ebec8;
                    `
                  : css`
                      color: #fff;
                      border: 1px solid #1ebec8;
                    `};
              background: transparent;
              &:hover {
                background: ${(props) => props.theme.colors.primary.main} !important;
                color: #fff;
                border: unset;
              }
            }
          }
        }

        ${media.desktop`
          margin-right: 0;
          padding: 10px 20px;
          border-bottom: 1px solid #000;
          width: 100%;
          text-align: right;

          > ul {
            margin: 0;
          }
        `};

        &:hover {
          color: ${(props) => props.theme.colorFlamingo};
        }
        &.active a.dropdown-toggle,
        &.active button,
        &.active > a:first-child {
          color: ${(props) => props.theme.colorFlamingo};
        }
      }
      .lp-nav-item .mega-dropdown {
        margin-right: 0;
      }
    }
  }

  .dropdown-toggle::after {
    content: none;
  }

  .lp-cart-dropdown,
  .lp-cart-dropdown-guest {
    padding-top: 22px;
  }

  .open > .dropdown-menu {
    display: block;
  }

  #topSearch {
    background: url(${searchIcon}) 10px 6px no-repeat ${(props) => props.theme.colors.primary.main};
  }

  .brand--name {
    font-weight: 600;
    font-size: 16px;
    font-family: "Nunito", sans-serif;
    a {
      color: #1ebec8;
    }
  }
  .mobile--search-bar {
    width: 100%;
    height: 80%;
    input {
      width: 100%;
      height: 100%;
      border: none;
      padding: 10px;
    }
    display: flex;
    border-radius: 6px;
    border: 2px solid ${(props) => props.theme.colors.primary.aqua};
  }
  .mobile--search-active {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  }

   .search__submit {
    color: #FFF;
    background-color: #59BBC6;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 1.9px;
    height: 46px;
    min-width: fit-content;
    border-radius: 3px !important;
    .MuiButton-label {
      gap: 8px;
      text-transform: none;
      padding-left: 10px;
      padding-right: 10px;
    }
  }

  .search-button-section {
    display: flex;
    background-color: #fff;
    padding-right: 6px;
    align-items: center;
  }

  .button__submit {
    height: 26px;
    border-radius: 3px !important;
    min-width: fit-content;
    color: #fff;
    background-color: #59bbc6;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 1.9px;
    border-left: 1px solid ${(props) => props.theme.colors.primary.aqua};
    .MuiButton-label {
      text-transform: none;
      gap: 8px;
      padding-left: 5px;
      padding-right: 5px;
    }
  }


  .input-wrapper {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
  .input-wrapper input {
    font-style: italic;
  }
   .star-icon {
    margin-left: 8px;
  }

  @media screen and (max-width: 640px) { 
    #topSearchBox {
      font-size: 12px;
    }
  }

  @media screen and (min-width: 992px) and (max-width: 1036px) {
    padding-right: 10px;
    .jukin-logo {
      margin-right: 10px !important;
    }
    .lp-nav-item {
      margin-right: 5px !important;
    }
  }
  @media screen and (max-width: 991px) {
    height: 50px;
    #navigation {
      height: 50px;
    }
    .cart-counter {
      margin-left: 9;
      margin-right: 20px;

      span {
        top: -2px;
      }
    }
    .jukin-logo {
      display: none;
    }
    .input-wrapper {
      background: white;
    }
  }
  @media (min-width: 900px) and (max-width: 1400px) {
    .signin {
      width: 72px !important;
    }

    .signup {
      width: 72px !important;
    }
  }
`;

export { HeaderContainer };
